import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { AndrichLogo } from "./Logo";

const NAV = [
  { label: "About", href: "#about" },
  { label: "Innovation", href: "#innovation" },
  { label: "Products", href: "#products" },
  { label: "Responsibility", href: "#responsibility" },
  { label: "Why Choose Us", href: "#why" },
  { label: "Contact", href: "#contact" },
];

export default function Navigation() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-navigation"
      className={`fixed top-0 inset-x-0 z-50 transition-shadow duration-300 ${
        scrolled ? "glass-nav shadow-[0_4px_20px_-12px_rgba(15,23,42,0.15)]" : "glass-nav"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-16 flex items-center justify-between">
        <a href="#top" className="shrink-0" data-testid="nav-logo-link">
          <AndrichLogo />
        </a>

        <nav className="hidden lg:flex items-center gap-8">
          {NAV.map((n) => (
            <a
              key={n.href}
              href={n.href}
              data-testid={`nav-link-${n.label.toLowerCase().replace(/\s/g, "-")}`}
              className="text-[0.85rem] font-medium text-slate-600 hover:text-blue-900 transition-colors"
            >
              {n.label}
            </a>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          <Link
            to="/admin/login"
            data-testid="nav-admin-link"
            className="text-[0.8rem] font-medium text-slate-500 hover:text-blue-900 transition-colors"
          >
            Admin
          </Link>
          <a href="#contact" className="btn-primary text-[0.8rem] py-2.5 px-5" data-testid="nav-cta-partner">
            Partner With Us
          </a>
        </div>

        <button
          className="lg:hidden inline-flex items-center justify-center h-10 w-10 rounded-full border border-slate-200 text-slate-700"
          onClick={() => setOpen((v) => !v)}
          data-testid="nav-mobile-toggle"
          aria-label="Toggle navigation"
        >
          {open ? <X size={18} /> : <Menu size={18} />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden border-t border-slate-200/70 bg-white/90 backdrop-blur-xl">
          <div className="px-6 py-4 flex flex-col gap-3">
            {NAV.map((n) => (
              <a
                key={n.href}
                href={n.href}
                onClick={() => setOpen(false)}
                data-testid={`nav-mobile-link-${n.label.toLowerCase().replace(/\s/g, "-")}`}
                className="text-sm text-slate-700 py-1"
              >
                {n.label}
              </a>
            ))}
            <Link to="/admin/login" onClick={() => setOpen(false)} data-testid="nav-mobile-admin" className="text-sm text-slate-500 py-1">
              Admin
            </Link>
            <a href="#contact" onClick={() => setOpen(false)} className="btn-primary text-xs mt-2 self-start" data-testid="nav-mobile-cta">
              Partner With Us
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
